import { get, put } from './api-crud';

export const getFeedbacks = () => {
  return get('base_url', '/get_feedbacks');
};

export const getAppRequests = () => {
  return get('base_url', '/fetch_requests');
};

export const approveRequest = (payload) => {
  return put('base_url', '/accept_request', payload);
};

export const getMasterData = () => {
  return get('base_url', '/get_master_data');
};

export const getDashboardCharts = (params = {}) => {
  const queryParams = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  return get('base_url', `/dashboard_charts${queryParams ? `?${queryParams}` : ''}`);
};
